export default function SearchListLoader() {
  return (
    <div style={{ marginTop: "64px" }}>
      <div className={"skeletonBlock"} style={{ height: "76px", borderRadius: "12px", marginBottom: "12px" }} />
      <div className={"skeletonBlock"} style={{ height: "76px", borderRadius: "12px", marginBottom: "12px" }} />
      <div className={"skeletonBlock"} style={{ height: "76px", borderRadius: "12px" }} />
    </div>
  )
}
